import React, { useState,useEffect }  from "react";
import { Container, Table } from "react-bootstrap";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import {getData} from '../api/protectedApi'
import ReactPaginate from 'react-paginate';

const LedgerIncome = () => {
  const [incomeData, setIncomeData] = useState([]);
      const [totalPages , setTotalPages] = useState(0); 
      const [startRec , setStartRec] = useState(1)
      const [incomeSum,setIncomeSum] = useState(0)
      const perPage = 10; 
      const ChangePage = (page) => { 
        getIncomeData(page);
      }
     const getIncomeData = async(page = 0) => { 
         await getData("/income_ledger?per_page="+perPage+"&page="+page)
           .then((res) => { 
               if(page > 1){
                 setStartRec(((page - 1) * perPage) + 1) 
               }else{
                  setStartRec(1)
               }
               setIncomeData(res.data.data)
               setTotalPages(parseInt(res.data.pagination.total_pages)) 
               setIncomeSum(res.data.income_balance)
           }) .catch((err) => console.error("ee", err)); 
     }
     useEffect(() => {
         getIncomeData()
       }, []);
  return (
    <div
      style={{
        backgroundColor: "#141915",
        minHeight: "100vh",
        padding: "40px 0",
        color: "#fff",
      }}
    >
      <Container style={{ maxWidth: "900px" }}>
        {/* NAVBAR */}
        <DashboardNavbar />
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-bold">Income Ledger</h4>
          <span className="text-white-50">
            Total:${incomeSum.toLocaleString()}
          </span>
        </div>

        <div
          style={{
            backgroundColor: "#2a352a",
            borderRadius: "12px",
            overflowX: "auto",
          }}
        >
          <Table responsive borderless className="m-0">
            <thead
              className="text-white"
              style={{ backgroundColor: "#2a352a" }}
            >
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                <th>S No.</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Description</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {incomeData.map((item, idx) => (
                <tr key={idx}>
                  <td  style={{ backgroundColor: "#2a352a", color: "#fff",  }}  >
                    { parseInt( startRec + idx)}  
                  </td>
                  <td style={{ backgroundColor: "#2a352a",  color: "#fff",  }} >
                    ${item.amount}
                  </td>
                  <td style={{ backgroundColor: "#2a352a", color: "#fff",  }} >
                    {item.type.replace("_", " ")}
                  </td>
                  <td style={{ backgroundColor: "#2a352a", color: "#fff",  }} >
                    {item.description}
                  </td>
                  <td style={{  backgroundColor: "#2a352a", color: "#fff",  }} >
                    {item.date}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <ReactPaginate
            breakLabel="..." 
            previousLabel={'←'}
            nextLabel={'→'}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={totalPages}
            onPageChange={({ selected }) => ChangePage(selected + 1)}
            containerClassName="pagination justify-content-center"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            activeClassName="active"
          />
        </div>
        <Footer />
      </Container>
    </div>
  );
};

export default LedgerIncome;
